export enum LocationEvents {
    inputLocationUpdated = 'input-location:updated',
    inputLocationValidated = 'input-location:validated',
}
